export default "__VITE_ASSET__B8scBeU3__"